import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import ImportantAlarm from '../components/ImportantAlarm';
import OldAppNotice from '../components/OldAppNotice';
import PageMeta from '../components/PageMeta';
import { syncBetaFromUrl, isScoreBeta } from '../utils/beta';
import HomeBeta from '../pages/HomeBeta';
import Tuner from '../pages/Tuner';
import SupportChat from '../pages/SupportChat';
import RequestScore from '../pages/RequestScore';
import Faq from '../pages/Faq';
import Howto from '../pages/Howto';
import HotClips from '../pages/HotClips';
import Pricing from '../pages/Pricing';
import AppIntro from '../pages/AppIntro';
import MyScoreList from '../pages/myScores/List';
import MyScoreNew from '../pages/myScores/New';
import MyScoreView from '../pages/myScores/View';
import MyScoreEdit from '../pages/myScores/Edit';
import MyScoreGroups from '../pages/myScores/Groups';
import BottomTabs, { RouteTracker } from '../components/BottomTabs';
import UpdateWatcher from '../components/UpdateWatcher';
import FeedbackPrompt from '../components/FeedbackPrompt';
import BetaGlobalStyle from '../components/BetaGlobalStyle';

import {
  Root,
  Login,
  Register,
  FindPassword,
  Password,
  Setting,
  PolicyPrivacy,
  PolicyService,
  SupportSubmit,
  SupportPost,
  Notice,
  Chart,
  Search,
  Membership,
  Playlist,
  PlaylistInformation,
  Notes,
  KakaoLogin,
  Logout,
  AuthError,
  Profile,
  Recent,
  Main,
  FullSheetMusic,
} from '../pages';
import Support from '../pages/Support';
import PrivateRoute from '../components/PrivateRoute';
import SNSLogin from '../pages/SNSLogin';
import { SWRConfig } from 'swr';
import { api } from '../utils/api';
import { noPurchaseUI } from '../utils/billing';
import { canAppPurchase, installIap } from '../utils/iap';
import { isEn } from '../utils/i18n';
import { startAutoTranslate } from '../utils/autoTranslate';
import AppSubscribe from '../pages/AppSubscribe';
import Modal from '../components/Modal';
import NoteRoute from "../components/NoteRoute";
import BillingSuccess from '../pages/BillingSuccess';
import BillingFail from '../pages/BillingFail';
import BillingMigrate from '../pages/BillingMigrate';

syncBetaFromUrl(); // ?beta=1 로 들어오면 이 기기에서 새 악보 화면 켜기

// 새 디자인 미리 써보기 계정이면 새 홈
const HomeSwitch: React.FC = () => (isScoreBeta() ? <HomeBeta /> : <Main />);
// 새 디자인이면 문의를 채팅 화면으로 (목록·작성 화면 대신)
const SupportSwitch: React.FC<any> = (props) => (isScoreBeta() ? <SupportChat /> : <Support {...props} />);
const SupportSubmitSwitch: React.FC<any> = (props) => (isScoreBeta() ? <SupportChat /> : <SupportSubmit {...props} />);

const App: React.FC = () => {
  const [isOpenConfirm, setIsOpenConfirm] = useState<boolean>(false);
  const swrConfig = {
    fetcher(url: string, params: object) {
      return api.get(url, { params }).then((res) => {
        return res.data?.data || res.data;
      });
    },
  };

  useEffect(() => {
    installIap(); // 앱 안 정기결제: 결제 결과 받을 곳 + 확인 못 한 구매 마저 확인
    if (isEn()) startAutoTranslate(); // 영어 화면: 화면 문구를 사전으로 바꿈 (utils/autoTranslate)
    // if (/iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    //   /Android/i.test(navigator.userAgent)) {
    //   // confirm("모바일 환경에서는 어플에서만 이용가능합니다.\n스토어로 이동할까요?")
    //   setIsOpenConfirm(true);
    // }
    // if (/Android/i.test(navigator.userAgent)) {
    //   // confirm("모바일 환경에서는 어플에서만 이용가능합니다.\n스토어로 이동할까요?")
    //   setIsOpenConfirm(true);

    // }
  }, [])
  const userAgent = window.navigator.userAgent.toLowerCase();

  const gotoStore = () => {
    if (/Android/i.test(navigator.userAgent)) {
      window.location.href = 'https://play.google.com/store/apps/details?id=kr.chordscore.app'
    }
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      window.location.href = 'https://apps.apple.com/kr/app/%EC%BD%94%EB%93%9C%EC%8A%A4%EC%BD%94%EC%96%B4-%EC%BD%94%EB%93%9C%EC%95%85%EB%B3%B4-%EC%97%B4%EB%9E%8C-%EC%84%9C%EB%B9%84%EC%8A%A4/id1550737595?l=en'
    }
  }

  const isAllowUserAgent = () => {
    return true;
    if (!/iPhone|iPad|iPod/i.test(navigator.userAgent) && !/Android/i.test(navigator.userAgent)) {
      return true;
    }
    alert(userAgent)
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      const safari = /safari/.test(userAgent);

      if (safari) {
        return false;
      } else {
        return true;
      }
    }

    return true;
  }

  return (
    <>
      {
        (isAllowUserAgent()) && (<SWRConfig value={swrConfig}>
          <BrowserRouter>
            <PageMeta />
            <Switch>
              <Route exact path="/" component={HomeSwitch} />
              <Route exact path="/tuner" component={Tuner} />
              <Route exact path="/request" component={RequestScore} />
              <Route exact path="/faq" component={Faq} />
              <Route exact path="/howto" component={Howto} />
              {/* 아이폰 앱 안에서는 가격·구독 화면 대신 첫 화면으로 (애플 심사 3.1.1, 2026-10-09) */}
              <Route exact path="/pricing" render={(p) => (canAppPurchase() ? <AppSubscribe /> : noPurchaseUI() ? <Redirect to="/" /> : <Pricing {...(p as any)} />)} />
              <Route exact path="/download" component={AppIntro} />
              <Route exact path="/hotclip" component={HotClips} />
              <Route exact path="/old-main" component={Root} />
              <Route exact path="/login" component={SNSLogin} />
              <Route exact path="/chart" component={Chart} />
              <Route exact path="/recent" component={Recent} />

              <Route exact path="/auth/login" component={Login} />
              <Route exact path="/auth/logout" component={Logout} />
              <Route exact path="/auth/register" component={Register} />
              <Route exact path="/auth/find-password" component={FindPassword} />
              <Route exact path="/auth/password" component={Password} />
              <Route exact path="/auth/profile" component={Profile} />
              <Route exact path="/auth/kakao" component={KakaoLogin} />
              <Route exact path="/auth/error" component={AuthError} />
              <Route exact path="/billing/success" component={BillingSuccess} />
              <Route exact path="/billing/fail" component={BillingFail} />
              <Route exact path="/billing/migrate" component={BillingMigrate} />

              <PrivateRoute exact path="/support" component={SupportSwitch}/>
              <PrivateRoute
                exact
                path="/support/submit"
                component={SupportSubmitSwitch}
              />
              <PrivateRoute
                exact
                path="/support/:postIdx"
                component={SupportPost}
              />

              <PrivateRoute exact path="/membership" component={Membership}/>
              <PrivateRoute exact path="/my-scores" component={MyScoreList}/>
              <PrivateRoute exact path="/my-scores/new" component={MyScoreNew}/>
              <PrivateRoute exact path="/my-scores/groups" component={MyScoreGroups}/>
              <PrivateRoute exact path="/my-scores/s/:token" component={MyScoreView}/>
              <PrivateRoute exact path="/my-scores/:id(\d+)/edit" component={MyScoreEdit}/>
              <PrivateRoute exact path="/my-scores/:id(\d+)" component={MyScoreView}/>

              <Route exact path="/search/:searchValue" component={Search} />

              <Route exact path="/policy/service" component={PolicyService} />
              <Route exact path="/policy/privacy" component={PolicyPrivacy} />

              <PrivateRoute exact path="/notice" component={Notice}/>
              <PrivateRoute exact path="/setting" component={Setting}/>

              <PrivateRoute exact path="/playlist" component={Playlist}/>
              <PrivateRoute
                exact
                path="/playlist/:playlistIdx"
                component={PlaylistInformation}
              />

              <NoteRoute exact path="/notes/:songIdx" component={Notes}/>
              <Route exact path="/full-sheet-music" component={FullSheetMusic} />
            </Switch>
            <ImportantAlarm />
            <OldAppNotice />
            <BottomTabs />
            <RouteTracker />
            <UpdateWatcher />
            <FeedbackPrompt />
            <BetaGlobalStyle />
          </BrowserRouter>
        </SWRConfig>
        )
      }
      <Modal
        open={isOpenConfirm}
        onClose={() => setIsOpenConfirm(false)}
        title="모바일 환경에서는 어플에서만 이용가능합니다."
        content="스토어로 이동할까요?"
        firstButtonLabel="확인"
        secondButtonLabel="취소"
        onClickFirstButton={gotoStore}
        onClickSecondButton={() => setIsOpenConfirm(false)}
      ></Modal>
    </>
  );
};

export default App;
